<!-- Button -->
<button
    class="text-black dark:text-slate-300"
    mat-icon-button
    [matTooltip]="tooltip || 'Toggle Fullscreen'"
    (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon class="text-black dark:text-slate-300"  [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
</ng-template>
